export const BOROGOVE_SETTINGS_FILE = ".borogove";
export const INPUT_TMP_PATH = "/input";
export const OUTPUT_TMP_PATH = "/output";
export const PERSISTENT_FILESYSTEM_DIR = "/persistent";
export const PROJECT_ROOT_DIR = "/project";
